import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FcDocument } from "react-icons/fc";
import { IoArrowBackSharp } from "react-icons/io5";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SortingRule } from "react-table";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import TableComponent, { OperationsCell, } from "../../components/TableComponent";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { BrandModelDTO } from "../../models/Kpi/BrandModelDTO";
import { Parameter } from "../../models/Parameter";
import { EquipmentService } from "../../services/EquipmentService";
import { KpiService } from "../../services/KpiService";

export default function KpiBrandModels() {
    const intl = useIntl();
    const navigate = useNavigate();
    const equipmentService = new EquipmentService();
    const kpiService = new KpiService();
    const pageSizes: number[] = [5, 15, 30];
    
    const [data, setData] = useState<BrandModelDTO[]>([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [goToPage, setGoToPage] = useState<number>();
    const [initialSortBy] = useState<SortingRule<object>[]>(Utilities.LoadSortParametersFromURLQuery("sortField", "sortOrder"));

    const [searchParams] = useSearchParams();
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageSize] = useState<number>(Utilities.LoadPageSizeFromURLQuery(pageSizes));
    const [currentPage, setCurrentPage] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [currentPageSize, setCurrentPageSize] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<SortingRule<object>[] | null>(null);

    const [brand, setBrand] = useState<string>(Utilities.LoadParameterFromURLQuery("brand", "string", ""));
    const [model, setModel] = useState<string>(Utilities.LoadParameterFromURLQuery("model", "string", ""));
    const [serialNumber, setSerialNumber] = useState<string>(Utilities.LoadParameterFromURLQuery("serialNumber", "string", ""));
    const [carPlate, setCarPlate] = useState<string>(Utilities.LoadParameterFromURLQuery("carPlate", "string", ""));
    const [id, setId] = useState<string>(Utilities.LoadParameterFromURLQuery("id", "number", ""));
    const [reloadSearch, setReloadSearch] = useState<boolean>(false);

    const [isActiveMaintenanceModule, setIsActiveMaintenanceModule] = useState<boolean>(false);
    const { availableModules, assistanceTypes } = useAvailableModulesContext();


    useEffect(() => {
        if (availableModules.includes("IsActiveMaintenanceModule")) {
          setIsActiveMaintenanceModule(true);
        }
      }, [availableModules]);
    
      const downloadDataSheet = async (id: number) => {
        setLoading(true);
        var response = await equipmentService.DownloadDataSheet(id);
        if (response.success === false) {
          Toast.Show("error", response.message);
          setLoading(false);
          return;
        }
    
        Toast.Show("success", response.message);
        setLoading(false);
      }

    const columns = React.useMemo(
        () => [
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
                    console.log("props.cell.row:", props.cell.row);
                  return (
                    <div style={{ display: "flex" }}>
                      {OperationsCell(props.cell.row.original.erpId, "equipment")}
                      {isActiveMaintenanceModule && props.cell.row.original.hasDataSheet &&
                        <Tooltip title="Ficha Técnica" aria-label="Ficha Técnica" enterNextDelay={500} enterDelay={500}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              alignContent: "center",
                              flexDirection: "column",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              downloadDataSheet(props.cell.row.original.id);
                            }}
                          >
                            <FcDocument className="icons" />
                          </div>
                        </Tooltip>
                      }
                    </div>
                  );
                },
                width: 5,
              },
            {
                Header: <FormattedMessage id="Screens.Kpi.BrandModels.Table.Brand" />,
                accessor: "brand",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.BrandModels.Table.Model" />,
                accessor: "model",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.BrandModels.Table.SerialNumber" />,
                accessor: "serialNumber",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.BrandModels.Table.CarPlate" />,
                accessor: "carPlate",
                width: 20,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.BrandModels.Table.Id" />,
                accessor: "id",
                width: 20,
            },
        ],
        []
    );

    const goBack = () => {
        navigate("/kpis");
    }

    const fetchData = async (
        page: number,
        pageSize: number,
        sortBy: SortingRule<object>[] | null
    ) => {
        //Atualizamos na history do browser a current page e pageSize

        var searchUrl: string = `?page=${page}&pageSize=${pageSize}` +
            `${Utilities.AddParamToQueryIfValue("brand", "string", brand)}` +
            `${Utilities.AddParamToQueryIfValue("model", "string", model)}` +
            `${Utilities.AddParamToQueryIfValue("serialNumber", "string", serialNumber)}`+
            `${Utilities.AddParamToQueryIfValue("carPlate", "string", carPlate)}` +
            `${Utilities.AddParamToQueryIfValue("id", "string", id)}`;

        if (sortBy != null && sortBy.length > 0) {
            searchUrl += `${Utilities.AddParamToQueryIfValue(
                "sortField",
                "string",
                sortBy[0].id
            )}${Utilities.AddParamToQueryIfValue(
                "sortOrder",
                "string",
                sortBy[0].desc === true ? "DESC" : "ASC"
            )}`;
        }

        //Se antes não existirem parâmetros de pesquisa, significa que o user veio para aqui de uma rota, então para não ficar com duas rotas duplicadas, fazemos replace à rota
        
        if (searchParams.toString() === "") {
            navigate(`/kpis/BrandModel${searchUrl}`, { replace: true });
        } else {
            //Se já existirem parâmetros de pesquisa, não fazemos replace mas push
            navigate(`/kpis/BrandModel${searchUrl}`);
        }

        setLoading(true);

        var response = await kpiService.GetByBrandModel(
            mountSearchParameters(),
            Utilities.MountSortParameters(sortBy),
            page,
            pageSize
        );

        if (response.success !== true) {
            setData([]);
            setPageCount(0);
            setLoading(false);
            setCurrentPageSize(5);
            setCurrentPage(1);
            setCurrentSorting(null);
            Toast.Show("error", response.message);
            return;
        }

        if (response.items.length === 0) {
            setCurrentPage(1);
            setGoToPage(1);
            Toast.Show("info", "Não existe nenhum equipamento com esses dados");
        }

        setData(response.items);
        setPageCount(response.totalPages);
        setLoading(false);
        setCurrentPageSize(pageSize);
        setCurrentPage(page);
        setCurrentSorting(sortBy);
        setGoToPage(0);

        if (response.totalPages > 0 && page > response.totalPages) {
            setGoToPage(1);
        }
    };

    const mountSearchParameters = (): Parameter[] => {
        var parameters: Parameter[] = [];
        parameters.push(new Parameter("brand", brand));
        parameters.push(new Parameter("model", model));
        parameters.push(new Parameter("serialNumber", serialNumber));
        parameters.push(new Parameter("carPlate", carPlate));
        parameters.push(new Parameter("id", id));

        return parameters;
    };

    const onEnter = () => {
        fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
    };

    const onButtonClick = async () => {
        setCurrentPage(1);
        setGoToPage(1);
        fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
    };

    const onRemoveFiltersClick = async () => {
        setCurrentPage(1);
        setGoToPage(1);
        setBrand("");
        setModel("");
        setSerialNumber("");
        setCarPlate("");
        setId("");
        setReloadSearch(true);
    };

    useEffect(() => {
        if (reloadSearch === true) {
            fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
            setReloadSearch(false);
        }
        return () => { };
    }, [reloadSearch]);

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <Col style={{ margin: "0px", padding: "0px" }}>
                            <span className="pageTitle"> <IoArrowBackSharp className="pageTitleBackIcon" onClick={goBack} /> <FormattedMessage id="Screens.Kpi.BrandModels.Title" />:
                            </span>
                        </Col>
                    </Row>
                </div>
                <div className="pageBody">
                    <Row>
                        <InputComponent
                            xl={3}
                            lg={2}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            type={"text"}
                            label={intl.formatMessage({ id: "Screens.Kpi.BrandModels.Filters.Brand" })}
                            readOnly={false}
                            value={brand}
                            onEnter={onEnter}
                            onChange={(t: string) => setBrand(t)}
                        />
                        <InputComponent
                            xl={3}
                            lg={2}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            type={"text"}
                            label={intl.formatMessage({ id: "Screens.Kpi.BrandModels.Filters.Model" })}
                            readOnly={false}
                            value={model}
                            onEnter={onEnter}
                            onChange={(t: string) => setModel(t)}
                        />
                        <InputComponent
                            xl={3}
                            lg={2}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            type={"text"}
                            label={intl.formatMessage({ id: "Screens.Kpi.BrandModels.Filters.SerialNumber" })}
                            readOnly={false}
                            value={serialNumber}
                            onEnter={onEnter}
                            onChange={(t: string) => setSerialNumber(t)}
                        />
                        <InputComponent
                            xl={3}
                            lg={2}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            type={"text"}
                            label={intl.formatMessage({ id: "Screens.Kpi.BrandModels.Filters.CarPlate" })}
                            readOnly={false}
                            value={carPlate}
                            onEnter={onEnter}
                            onChange={(t: string) => setCarPlate(t)}
                        />
                        <InputComponent
                            xl={1}
                            lg={2}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            type={"number"}
                            label={intl.formatMessage({ id: "Screens.Kpi.BrandModels.Filters.Id" })}
                            readOnly={false}
                            value={id}
                            onEnter={onEnter}
                            onChange={(t: string) => setId(t)}
                        />
                    </Row>
                    <Row>
                        <Col
                            xl={6}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}>
                            <ButtonComponent
                                text={intl.formatMessage({ id: "Common.Buttons.Search" })}
                                onClick={onButtonClick}
                            />
                            <ButtonComponent 
                                text={intl.formatMessage({ id: "Common.Buttons.RemoveFilters" })}
                                onClick={onRemoveFiltersClick}
                            />
                        </Col>
                    </Row>
                    <div className="pageComponent" style={{ width: "100%" }}>
                        <TableComponent
                            goToPage={goToPage}
                            loading={loading}
                            pageCount={pageCount}
                            columns={columns}
                            manualPagination={true}
                            fetchData={fetchData}
                            pageSizes={pageSizes}
                            initialPage={page}
                            initialPageSize={pageSize}
                            initialSortBy={initialSortBy}
                            data={data}
                            dontOrderFirstCollumn={true}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
}